import script from "./addOrEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./addOrEdit.vue?vue&type=script&setup=true&lang=js"

import "./addOrEdit.vue?vue&type=style&index=0&id=7aa38ccc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aa38ccc"]])

export default __exports__